export const FONCTIONETP_RESET = "FONCTIONETP_RESET";
export const FONCTIONETP_SET_ERROR = "FONCTIONETP_SET_ERROR";
export const FONCTIONETP_SET_ITEMS = "FONCTIONETP_SET_ITEMS";
export const FONCTIONETP_TOGGLE_LOADING = "FONCTIONETP_TOGGLE_LOADING";
